
/* LUNA BABY | PRODUCT FORM 2.0 */

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {

    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );

      this.cart =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      this.submitButton = this.querySelector('[type="submit"]');

      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') {
        return;
      }

      this.handleErrorMessage();
      this.error = false;

      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');

      const spinner = this.querySelector('.loading-overlay__spinner');
      spinner?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        const sections = this.cart.getSectionsToRender();

        formData.append(
          'sections',
          sections.map(section => section.id).join(',')
        );

        formData.append(
          'sections_url',
          window.location.pathname
        );

        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      try {
        const response = await fetch(
          routes.cart_add_url,
          config
        );

        const data = await response.json();

        if (!response.ok || data.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: data.description,
            message: data.message
          });

          this.handleErrorMessage(
            data.description || data.message || 'Unable to add product.'
          );

          if (data.status === 422) {
            const soldOutMessage = this.submitButton.querySelector(
              '.sold-out-message'
            );

            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', 'true');
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
          }

          this.error = true;
          return;
        }

        if (!this.cart) {
          window.location.href = window.routes.cart_url;
          return;
        }

        const notifyCartUpdate = () => {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id')
          });
        };

        const quickAddModal = this.closest('quick-add-modal');

        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              this.cart.renderContents(data);
              setTimeout(notifyCartUpdate, 0);
            },
            { once: true }
          );

          quickAddModal.hide(true);
        } else {
          this.cart.renderContents(data);
          setTimeout(notifyCartUpdate, 0);
        }

      } catch (error) {
        console.error('[Luna Cart] Add to cart error:', error);
        this.handleErrorMessage(
          'Unable to add product. Please try again.'
        );
        this.error = true;

      } finally {
        this.submitButton.classList.remove('loading');

        if (this.cart?.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }

        if (!this.error) {
          this.submitButton.removeAttribute('aria-disabled');
        }

        spinner?.classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper ||
        this.querySelector('.product-form__error-message-wrapper');

      if (!this.errorMessageWrapper) return;

      this.errorMessage =
        this.errorMessage ||
        this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute(
        'hidden',
        !errorMessage
      );

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* ORIGINAL STICKY CART BEHAVIOR */

class stickyCartModal extends HTMLElement {
  constructor() {
    super();

    window.addEventListener('scroll', this.update.bind(this));
    this.update();

    document.querySelector('footer')
      ?.classList.add('sticky-cart-modal_bottom_padding');
  }

  update() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );

    if (!button) return;

    const addButton = button.querySelector('[name="add"]');
    if (!addButton) return;

    const rangeToShowModal =
      this.getTop(addButton) + button.clientHeight;

    if (
      window.scrollY >= rangeToShowModal &&
      !this.classList.contains('show-modal')
    ) {
      this.classList.add('show-modal');
      document.body.classList.add('modal__sticky-cart');
    }

    if (
      window.scrollY < rangeToShowModal &&
      this.classList.contains('show-modal')
    ) {
      this.classList.remove('show-modal');
      document.body.classList.remove('modal__sticky-cart');
    }
  }

  getTop(el) {
    return el.offsetTop +
      (el.offsetParent ? this.getTop(el.offsetParent) : 0);
  }
}

if (!customElements.get('sticky-cart-modal')) {
  customElements.define('sticky-cart-modal', stickyCartModal);
}
